export { MorphemeInfoPanelDictionaryWordSection } from "#morpheme-info-panel-dictionary-word-section";
